import React, { useState, useRef, useEffect } from 'react';
import {
    getPlatformNavItems,
    brandIconUrl,
    platformUrl,
    qcenterSvgIconUrl,
} from '../lib/platformNavigation';

function NavIcon({ htkBackend, icon, iconSvg, compact }) {
    if (iconSvg) {
        return (
            <img
                className="platform-nav-svg-icon"
                src={qcenterSvgIconUrl(htkBackend, iconSvg)}
                alt=""
            />
        );
    }
    return (
        <img
            className={compact ? 'imgQwebHeader' : 'mini-icon'}
            src={brandIconUrl(htkBackend, icon)}
            alt=""
        />
    );
}

function NavDropdown({ item, htkBackend, compact }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        if (!open) {
            return undefined;
        }
        const onDocClick = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', onDocClick);
        return () => document.removeEventListener('mousedown', onDocClick);
    }, [open]);

    return (
        <li className="nav-item me-1 dropdown platform-nav-item" ref={ref}>
            <button
                type="button"
                className="nav-link platform-nav-link dropdown-toggle border-0 bg-transparent"
                onClick={() => setOpen((v) => !v)}
                aria-expanded={open}
            >
                <NavIcon htkBackend={htkBackend} icon={item.icon} compact={compact} />
                <span className={compact ? 'd-none' : 'd-none d-xl-inline'}>{item.label}</span>
            </button>
            {open && (
                <div className="dropdown-menu show platform-nav-dropdown">
                    {item.children.map((child, idx) => {
                        if (child.type === 'divider') {
                            return <hr key={`div-${idx}`} className="dropdown-divider" />;
                        }
                        return (
                            <a
                                key={child.path}
                                className="dropdown-item"
                                href={platformUrl(htkBackend, child.path)}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <NavIcon
                                    htkBackend={htkBackend}
                                    icon={child.icon}
                                    iconSvg={child.iconSvg}
                                    compact={compact}
                                />
                                {' '}{child.label}
                            </a>
                        );
                    })}
                </div>
            )}
        </li>
    );
}

function NavLinkItem({ item, htkBackend, compact }) {
    return (
        <li className="nav-item me-1 platform-nav-item">
            <a
                className="nav-link platform-nav-link"
                href={platformUrl(htkBackend, item.path)}
                target="_blank"
                rel="noopener noreferrer"
            >
                <NavIcon htkBackend={htkBackend} icon={item.icon} compact={compact} />
                <span className={compact ? 'd-none' : 'd-none d-xl-inline'}>{item.label}</span>
            </a>
        </li>
    );
}

export default function PlatformNavBar({
    htkBackend,
    userTipo,
    currentUser,
    assetsBase,
    compact = false,
    extraActions = null,
}) {
    const navItems = getPlatformNavItems(userTipo);
    const userHref = (assetsBase || '').replace(/\/+$/, '') + '/';

    return (
        <>
            <nav className={`navbar navbar-expand-sm platform-nav-inner${compact ? ' platform-nav-inner--compact' : ''}`}>
                <div className="d-flex flex-xl-row align-items-center">
                    <a
                        className="navbar-brand platform-nav-logo"
                        href={platformUrl(htkBackend, '/')}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            src={platformUrl(htkBackend, '/brand/QWEB.png')}
                            className={compact ? 'imgQwebHeader1' : 'qWeb-icon'}
                            alt="QWEB"
                        />
                    </a>

                    <ul className="navbar-nav d-flex flex-row flex-xl-row platform-nav-items">
                        {navItems.map((item) =>
                            item.type === 'dropdown' ? (
                                <NavDropdown key={item.id} item={item} htkBackend={htkBackend} compact={compact} />
                            ) : (
                                <NavLinkItem key={item.path} item={item} htkBackend={htkBackend} compact={compact} />
                            )
                        )}
                    </ul>
                </div>
            </nav>

            {extraActions && (
                <div className="platform-nav-extra navbar-nav">
                    {extraActions}
                </div>
            )}

            <div className="navbar-nav ml-auto platform-nav-user">
                <div className="nav-item d-flex align-items-center">
                    <img
                        className={compact ? 'imgQwebHeader' : 'mini-icon'}
                        src={brandIconUrl(htkBackend, 'USERS.png')}
                        alt=""
                    />
                    <a
                        className="nav-link platform-nav-link platform-nav-user-link"
                        href={userHref}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {currentUser.completeName}
                    </a>
                </div>
            </div>
        </>
    );
}
